import React from "react";
import "./aboutUs.css";
import { FormattedMessage } from "react-intl";

export const AboutUs = () => {
  return (
    <div>
      <h2 style={{ textAlign: "center", marginTop: 40 }}>
        <FormattedMessage id="AboutUs.title" defaultMessage="What we do" />
      </h2>
      <p className="subtitle">
        {" "}
        <FormattedMessage id="AboutUs.subtitle" />
      </p>
      <div className="whatWeDo">{renderWhatWeDoBlocks()}</div>
      <div className="aboutUs">
        <div className="video">
          <iframe
            src="https://www.youtube.com/embed/Oug4PD3KevY"
            frameBorder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            title="Opseeker Startupbootcamp pitch"
            allowFullScreen
          />
        </div>
        <div>
          <h3>
            <FormattedMessage id="AboutUs.textTitle" defaultMessage="title" />
          </h3>
          <p>
            <FormattedMessage
              id="AboutUs.textBlock1"
              defaultMessage="paragraph1"
            />
          </p>
          <p style={{ paddingLeft: 30 }}>
            <FormattedMessage
              id="AboutUs.textBlock2"
              defaultMessage="paragraph2"
            />
          </p>
        </div>
      </div>
    </div>
  );
};

const renderWhatWeDoBlocks = () => {
  let i = 0;
  let blocksCount = 4;
  let blocks = [];
  while (i < blocksCount) {
    i++;
    blocks.push(
      <div className={"wwd" + i} key={i}>
        <span
          style={{
            backgroundImage:
              "url(" +
              process.env.REACT_APP_MEDIA_CONTENT +
              "what_we_do-0" +
              (i + 1) +
              ".png)"
          }}
        />
        <h3>
          <FormattedMessage
            id={"WhatWeDo.block" + i + "Title"}
            defaultMessage={"title" + i}
          />
        </h3>
        <p>
          <FormattedMessage
            id={"WhatWeDo.block" + i + "Text"}
            defaultMessage={"text" + i}
          />
        </p>
      </div>
    );
  }
  return blocks;
};

export default AboutUs;



// WEBPACK FOOTER //
// ./src/containers/aboutUs/AboutUs.js